export default {
    confirmationHideBroadcast: 'Do you want to stop broadcasting?',
    warningHideBroadcast:
        'IMPORTANT: Selecting "No" will only hide the video stream for you but others will continue to see your broadcast.',
    unhideBroadcast1: 'Select the cam icon',
    unhideBroadcast2: "in the app's header to see your own video stream again.",
    broadcasting: 'Broadcasting',
    broadcastRule1: 'Anyone appearing on cam must be over 18.',
    broadcastRule2: 'Do NOT broadcast copyrighted material.',
    broadcastRule3: 'Conduct that may be considered obscene is forbidden.',
    broadcastRule4:
        'Do NOT violate the law or the standards of your community.',
    cameraNotFound: 'Camera Not Found',
    confirmationStartBroadcast: 'Are you sure you want to start broadcasting?',
    confirmationStopBroadcast: 'Are you sure you want to stop broadcasting?',
    iAgree: 'I Agree',
    infoEveryone:
        'Only premium members and models have access to your webcam broadcast. Guests and regular users are not able to view member webcams.',
    initializingWebcam: 'Initializing webcam...',
    label_onlyAllowedViewers: 'People added to "Allowed Viewers"',
    label_everyone: 'Everyone',
    label_onlyFriendsList: 'Friends',
    label_onlyFriendsAndModels: 'Friends and models',
    label_onlyModels: 'Only models',
    label_onlySpecifiedFriend: 'A specific friend',
    myWebcam: 'My Webcam',
    notBroadcasting: 'Not Broadcasting',
    startBroadcasting: 'Start Broadcasting',
    stopBroadcasting: 'Stop Broadcasting',
    user: 'User',
    whileSharingTheirWebcamStream:
        'While sharing their webcam stream, members may NOT',
    whoCanWatchYourWebcam: 'Who can watch my webcam?',
    youAreBroadcasting: 'You are broadcasting',
    broadcastingOff: 'Not broadcasting',
    broadcastingOn: 'Broadcasting',
    broadcastingError: 'Broadcasting error',
    broadcastingNotAvailable: 'Broadcasting not available',
    youMustAgreeRules: 'You must agree to the following rules',
    rulesMoreDetails: 'For more details, please visit our',
    wiki: 'wiki',
    tooltipBroadcastWillOnly:
        'Only premium members and models have access to your webcam broadcast. Guests and regular users are not able to view member webcams. If you choose a specific friend, it will only be visible if that friend has also befriended you',
    uninitialized: 'Not broadcasting',
    manageViewers: 'Manage Viewers',
    allowAViewer: 'Allow A Viewer',
    allowAViewerDescription:
        'Enter the usernames of users whom you want to allow access to your cam.',
    blockAViewer: 'Block A Viewer',
    blockAViewerDescription:
        'Enter the usernames of users whom you want to block access to your cam.',
    allowedViewers: 'Allowed Viewers',
    blockedViewers: 'Blocked Viewers',
    addButton: 'Add',
    removeButton: 'Remove',
    enterUsername: 'Please enter a username.',
    viewerAlreadyInList: 'This user is already in the list.',
    securitySettingsRestart:
        'Your new security settings will not take effect until you have restarted your webcam.',
}
